'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var components_Button_Button_component = require('../../../components/Button/Button.component.js');
var formik = require('formik');
var _get = require('lodash/get');
var Forms_components_Toggled = require('../../../Forms/components/Toggled.js');
var Loads = require('react-loads');
var PaymentMethods_components_CardDetailsBox = require('../../../PaymentMethods/components/CardDetailsBox.js');
var components_ErrorMessage = require('../../../components/ErrorMessage.js');
var PaymentMethods_PaymentCardInputs = require('../../../PaymentMethods/PaymentCardInputs.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faPlus = require('@fortawesome/pro-solid-svg-icons/faPlus');
var faTrashAlt = require('@fortawesome/pro-solid-svg-icons/faTrashAlt');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
require('clsx');
require('../../../tw-merge-2e22aa15.js');
require('@medipass/assets/images/mastercard.svg');
require('@medipass/assets/images/visa.svg');
require('../../../components/BriefDetailBox.js');
require('redux-form');
require('react-payment-inputs');
require('react-payment-inputs/lib/utils/validator');
require('@fortawesome/pro-regular-svg-icons/faCreditCard');
require('@fortawesome/pro-regular-svg-icons/faCalendarAlt');
require('@fortawesome/pro-regular-svg-icons/faLockAlt');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var Loads__default = /*#__PURE__*/_interopDefaultLegacy(Loads);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var SelectableCardDetailsBox = bumbag.styled(PaymentMethods_components_CardDetailsBox["default"])(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  background-color: ", ";\n  cursor: pointer;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), bumbag.palette('white800'), function (props) {
  return !props.isSelected && props.isExpired && bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n      opacity: 0.7;\n      &:focus,\n      &:hover,\n      &:hover:active,\n      &:active {\n        color: inherit;\n        background-color: ", ";\n      }\n    "])), bumbag.palette('white900')(props));
}, function (props) {
  return props.isSelected && props.isExpired && // @ts-expect-error TS(2769): No overload matches this call.
  bumbag.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n      color: ", ";\n      background-color: ", ";\n      opacity: 0.7;\n\n      &:focus,\n      &:hover,\n      &:hover:active,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n      }\n    "])), bumbag.palette('white')(props), bumbag.palette('danger700')(props), bumbag.palette('white'), bumbag.palette('danger700')(props));
}, function (props) {
  return props.isSelected && !props.isExpired && // @ts-expect-error TS(2769): No overload matches this call.
  bumbag.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose__default["default"](["\n      color: ", ";\n      background-color: ", ";\n\n      &:focus,\n      &:hover,\n      &:hover:active,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n      }\n    "])), bumbag.palette('white')(props), bumbag.palette('primary')(props), bumbag.palette('white'), bumbag.palette('primary')(props));
}, function (props) {
  return !props.isSelected && !props.isExpired && bumbag.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose__default["default"](["\n      &:hover,\n      &:hover:active,\n      &:active {\n        color: inherit;\n        background-color: ", ";\n      }\n    "])), bumbag.palette('white900')(props));
});

var PaymentMethod = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose__default["default"](PaymentMethod, _React$Component);

  function PaymentMethod() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      error: null,
      selectedPaymentMethod: _this.props.selectedPaymentMethod
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "componentDidUpdate", function (prevProps) {
      if (_get__default["default"](_this.props, 'selectedPaymentMethod._id') !== _get__default["default"](prevProps, 'selectedPaymentMethod._id')) {
        _this.setState({
          selectedPaymentMethod: _this.props.selectedPaymentMethod
        });
      }
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleClickNewPaymentCard", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(_ref) {
        var setAddNewCard, onChangePaymentMethod;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setAddNewCard = _ref.setAddNewCard;
                onChangePaymentMethod = _this.props.onChangePaymentMethod;

                if (!onChangePaymentMethod) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return onChangePaymentMethod({});

              case 5:
                setAddNewCard(); // @ts-expect-error Expected more then one argument bro. but not gonna touch it

                _this.handleSelectPaymentMethod({});

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleSelectPaymentMethod", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(paymentMethod, _ref3) {
        var cancelAddNewCard, onChangePaymentMethod;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cancelAddNewCard = _ref3.cancelAddNewCard;
                onChangePaymentMethod = _this.props.onChangePaymentMethod;
                cancelAddNewCard && cancelAddNewCard();

                _this.setState({
                  selectedPaymentMethod: paymentMethod
                });

                _context2.prev = 4;

                if (!onChangePaymentMethod) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return onChangePaymentMethod(paymentMethod);

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);

                _this.setState({
                  // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Record<s... Remove this comment to see the full error message
                  error: _context2.t0
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 10]]);
      }));

      return function (_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleRemovePaymentMethod", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(paymentMethodId) {
        var onClickRemovePaymentMethod;
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                onClickRemovePaymentMethod = _this.props.onClickRemovePaymentMethod;
                _context3.t0 = onClickRemovePaymentMethod;

                if (!_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return onClickRemovePaymentMethod(paymentMethodId);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          isRequired = _this$props.isRequired,
          paymentMethods = _this$props.paymentMethods,
          showRememberCardDetails = _this$props.showRememberCardDetails,
          enableRemovePaymentMethod = _this$props.enableRemovePaymentMethod;
      var _this$state = _this.state,
          error = _this$state.error,
          selectedPaymentMethod = _this$state.selectedPaymentMethod;
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, paymentMethods.length === 0 ? /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
        position: "relative"
      }, /*#__PURE__*/React__default["default"].createElement(PaymentMethods_PaymentCardInputs["default"], {
        isRequired: isRequired,
        formType: "formik",
        size: "large",
        variant: "wrapped"
      }), showRememberCardDetails && /*#__PURE__*/React__default["default"].createElement(formik.FastField, {
        name: "rememberCardDetails",
        component: bumbag.Checkbox.Formik,
        label: "Save my credit card details at this business to enable them to process payments on my behalf.",
        marginTop: "major-2"
      })) : /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(Forms_components_Toggled["default"], null, function (_ref6) {
        var getAddNewCardTogglerProps = _ref6.getElementTogglerProps,
            isAddingNewCard = _ref6.on,
            setAddNewCard = _ref6.setOn,
            cancelAddNewCard = _ref6.setOff;
        return /*#__PURE__*/React__default["default"].createElement(bumbag.Stack, {
          spacing: "major-2"
        }, /*#__PURE__*/React__default["default"].createElement(Loads__default["default"], {
          contextKey: "delete-payment-method",
          load: _this.handleRemovePaymentMethod
        }, function (_ref7) {
          var load = _ref7.load;
              _ref7.response;
              var error = _ref7.error,
              isError = _ref7.isError;
              _ref7.isIdle;
              var isLoading = _ref7.isLoading;
              _ref7.isSuccess;
          return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, !isAddingNewCard && /*#__PURE__*/React__default["default"].createElement(bumbag.Stack, {
            spacing: "major-1",
            "aria-label": "Payment Methods"
          }, paymentMethods.map(function (paymentMethod) {
            var isSelected = Boolean(selectedPaymentMethod && paymentMethod._id === selectedPaymentMethod._id);

            var isCardExpired = function isCardExpired(paymentMethod) {
              var expiryDate = new Date(paymentMethod == null ? void 0 : paymentMethod.expiryYear, (paymentMethod == null ? void 0 : paymentMethod.expiryMonth) - 1, 1);
              return expiryDate < new Date();
            };

            var isExpired = isCardExpired(paymentMethod);
            return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
              key: paymentMethod._id
            }, /*#__PURE__*/React__default["default"].createElement(SelectableCardDetailsBox, _extends__default["default"]({
              key: paymentMethod._id // @ts-expect-error TS(2322): Type '{ addonComponent?: Element; key: any; role: ... Remove this comment to see the full error message
              ,
              role: "button",
              tabIndex: "0",
              isSelected: isSelected,
              isExpired: isExpired,
              lastFour: paymentMethod.lastFour,
              onClick: function onClick() {
                return _this.handleSelectPaymentMethod(paymentMethod, {
                  cancelAddNewCard: cancelAddNewCard
                });
              },
              type: paymentMethod.cardType,
              "aria-pressed": isSelected
            }, enableRemovePaymentMethod ? {
              addonComponent: /*#__PURE__*/React__default["default"].createElement(components_Button_Button_component.Button, {
                palette: isSelected ? 'muted' : 'danger',
                variant: "link",
                onClick: function onClick() {
                  return load(paymentMethod == null ? void 0 : paymentMethod._id);
                },
                loading: isLoading
              }, /*#__PURE__*/React__default["default"].createElement("div", {
                className: "flex items-center justify-center whitespace-nowrap"
              }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
                icon: faTrashAlt.faTrashAlt,
                className: "mr-2"
              }), /*#__PURE__*/React__default["default"].createElement("span", null, "Remove")))
            } : {})));
          })), isError &&
          /*#__PURE__*/
          // @ts-expect-error TS(2322): Type '{ children: Element; hasIcon: true; hasTint:... Remove this comment to see the full error message
          React__default["default"].createElement(bumbag.Alert, {
            hasIcon: true,
            hasTint: true,
            marginTop: "major-2",
            type: "danger"
          }, /*#__PURE__*/React__default["default"].createElement(components_ErrorMessage["default"], {
            description: "Unable to remove payment card",
            err: error
          })));
        }), isAddingNewCard ? /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(PaymentMethods_PaymentCardInputs["default"], {
          isRequired: isRequired,
          formType: "formik",
          size: "large",
          variant: "wrapped"
        }), showRememberCardDetails && /*#__PURE__*/React__default["default"].createElement(formik.FastField, {
          name: "rememberCardDetails",
          component: bumbag.Checkbox.Formik,
          label: "Save my credit card details at this business to enable them to process payments on my behalf.",
          marginTop: "major-1"
        })) : /*#__PURE__*/React__default["default"].createElement(components_Button_Button_component.Button, _extends__default["default"]({}, getAddNewCardTogglerProps(), {
          palette: "secondary",
          variant: "ghost",
          onClick: function onClick() {
            return _this.handleClickNewPaymentCard({
              setAddNewCard: setAddNewCard
            });
          }
        }), /*#__PURE__*/React__default["default"].createElement("div", {
          className: "flex items-center justify-center whitespace-nowrap"
        }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faPlus.faPlus,
          className: "mr-2 text-base antialiased"
        }), /*#__PURE__*/React__default["default"].createElement("span", null, "Add new card"))));
      }), error &&
      /*#__PURE__*/
      // @ts-expect-error TS(2322): Type '{ children: Element; hasIcon: true; hasTint:... Remove this comment to see the full error message
      React__default["default"].createElement(bumbag.Alert, {
        hasIcon: true,
        hasTint: true,
        marginTop: "major-2",
        type: "danger"
      }, /*#__PURE__*/React__default["default"].createElement(components_ErrorMessage["default"], {
        description: "Unable to use selected payment card",
        err: error
      }))));
    });

    return _this;
  }

  return PaymentMethod;
}(React__default["default"].Component);

_defineProperty__default["default"](PaymentMethod, "defaultProps", {
  isRequired: true,
  onChangePaymentMethod: null,
  onClickRemovePaymentMethod: undefined,
  selectedPaymentMethod: null,
  showRememberCardDetails: false,
  enableRemovePaymentMethod: false
});

exports["default"] = PaymentMethod;
